import { Button, Tooltip } from 'antd';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import type { TComponent } from 'utils/types/component';

import styles from './ExportButton.module.scss';

interface IExportButtonProps {
    onClick: () => void;
    className?: string;
}

export const ExportButton: TComponent<IExportButtonProps> = (props) => {
    const { onClick, className } = props;

    const { t } = useTranslation();

    return (
        <Button
            onClick={onClick}
            className={cn(styles.exportButton, className)}
        >
            <Tooltip title={t('common.export')}>
                {t('common.buttons.export')}
            </Tooltip>
        </Button>
    );
};
